import CompanyUsersService from '../../services/CompanyUsersService';

// Action Types
export const COMPANY_USERS_LOADING = 'COMPANY_USERS_LOADING';
export const COMPANY_USERS_SUCCESS = 'COMPANY_USERS_SUCCESS';
export const COMPANY_USERS_FAIL = 'COMPANY_USERS_FAIL';
export const COMPANY_USER_GET_SUCCESS = 'COMPANY_USER_GET_SUCCESS';
export const COMPANY_USER_CREATE_SUCCESS = 'COMPANY_USER_CREATE_SUCCESS';
export const COMPANY_USER_UPDATE_SUCCESS = 'COMPANY_USER_UPDATE_SUCCESS';
export const COMPANY_USER_DELETE_SUCCESS = 'COMPANY_USER_DELETE_SUCCESS';
export const COMPANY_USERS_CLEAR_ERRORS = 'COMPANY_USERS_CLEAR_ERRORS';
export const COMPANY_USERS_CLEAR_CURRENT = 'COMPANY_USERS_CLEAR_CURRENT';
export const COMPANY_USERS_SET_PAGINATION = 'COMPANY_USERS_SET_PAGINATION';
export const MY_COMPANIES_SUCCESS = 'MY_COMPANIES_SUCCESS';

// Role Assignment Action Types
export const COMPANY_USER_ASSIGNMENTS_LOADING = 'COMPANY_USER_ASSIGNMENTS_LOADING';
export const COMPANY_USER_ASSIGNMENTS_SUCCESS = 'COMPANY_USER_ASSIGNMENTS_SUCCESS';
export const COMPANY_USER_ROLE_ASSIGN_SUCCESS = 'COMPANY_USER_ROLE_ASSIGN_SUCCESS';
export const COMPANY_USER_ROLE_UPDATE_SUCCESS = 'COMPANY_USER_ROLE_UPDATE_SUCCESS';
export const COMPANY_USER_ROLE_REMOVE_SUCCESS = 'COMPANY_USER_ROLE_REMOVE_SUCCESS';

// Action Creators

// Set loading state
export const setLoading = () => ({
    type: COMPANY_USERS_LOADING
});

// Clear errors
export const clearErrors = () => ({
    type: COMPANY_USERS_CLEAR_ERRORS
});

// Clear current user
export const clearCurrentUser = () => ({
    type: COMPANY_USERS_CLEAR_CURRENT
});

// Get company users with search/filter
export const getCompanyUsersAction = (companyId, params = {}) => {
    return async (dispatch) => {
        try {
            dispatch(setLoading());
            
            const response = await CompanyUsersService.searchCompanyUsers(companyId, params);
            
            if (response.success) {
                dispatch({
                    type: COMPANY_USERS_SUCCESS,
                    payload: response.data
                });
                
                if (response.pagination) {
                    dispatch({
                        type: COMPANY_USERS_SET_PAGINATION,
                        payload: response.pagination
                    });
                }
            } else {
                dispatch({
                    type: COMPANY_USERS_FAIL,
                    payload: response.message || 'Failed to fetch company users'
                });
            }
            
            return response;
        } catch (error) {
            const errorMessage = error.message || 'An error occurred while fetching company users';
            dispatch({
                type: COMPANY_USERS_FAIL,
                payload: errorMessage
            });
            throw error;
        }
    };
};

// Get company user by assignment ID
export const getCompanyUserByIdAction = (companyId, assignmentId) => {
    return async (dispatch) => {
        try {
            dispatch(setLoading());
            
            const response = await CompanyUsersService.getCompanyUserByAssignmentId(companyId, assignmentId);
            
            if (response.success) {
                dispatch({
                    type: COMPANY_USER_GET_SUCCESS,
                    payload: response.data
                });
            } else {
                dispatch({
                    type: COMPANY_USERS_FAIL,
                    payload: response.message || 'Failed to fetch user details'
                });
            }
            
            return response;
        } catch (error) {
            const errorMessage = error.message || 'An error occurred while fetching user details';
            dispatch({
                type: COMPANY_USERS_FAIL,
                payload: errorMessage
            });
            throw error;
        }
    };
};

// Create company user
export const createCompanyUserAction = (companyId, userData, callback) => {
    return async (dispatch) => {
        try {
            dispatch(setLoading());
            const response = await CompanyUsersService.createUserInCompany(companyId, userData);
            console.log('response123', response);
            if (response.success) {
                dispatch({
                    type: COMPANY_USER_CREATE_SUCCESS,
                    payload: response.data
                });
                if (callback) {
                    callback(response.message || 'User created successfully', response.data, true);
                }
            } else {
                const errorMessage = response.message || 'Failed to create user';
                if (response.data && Array.isArray(response.data)) {
                    dispatch({
                        type: COMPANY_USERS_FAIL,
                        payload: errorMessage,
                        validationErrors: response.data
                    });
                } else {
                    dispatch({
                        type: COMPANY_USERS_FAIL,
                        payload: errorMessage
                    });
                }
                if (callback) {
                    callback(errorMessage, {}, false);
                }
            }
            
            return response;
        } catch (error) {
            let errorMessage = 'An error occurred while creating the user';
            let validationErrors = null;
            
            if (error.message) {
                errorMessage = error.message;
            }
            if (error.validationErrors && Array.isArray(error.validationErrors)) {
                validationErrors = error.validationErrors;
            }
            
            dispatch({
                type: COMPANY_USERS_FAIL,
                payload: errorMessage,
                validationErrors: validationErrors
            });
            if (callback) {
                callback(errorMessage, {}, false);
            }
            throw error;
        }
    };
};

// Update company user
export const updateCompanyUserAction = (companyId, assignmentId, userData, callback) => {
    return async (dispatch) => {
        try {
            dispatch(setLoading());
            
            const response = await CompanyUsersService.updateCompanyUserProfile(
                companyId,
                assignmentId,
                userData
            );
            
            if (response.success) {
                dispatch({
                    type: COMPANY_USER_UPDATE_SUCCESS,
                    payload: response.data
                });
                if (callback) {
                    callback(response.message || 'User updated successfully', response.data, true);
                }
            } else {
                const errorMessage = response.message || 'Failed to update user';
                console.log('errorMessage', errorMessage);
                if (response.data && Array.isArray(response.data)) {
                    dispatch({
                        type: COMPANY_USERS_FAIL,
                        payload: errorMessage,
                        validationErrors: response.data
                    });
                } else {
                    dispatch({
                        type: COMPANY_USERS_FAIL,
                        payload: errorMessage
                    });
                }
                if (callback) {
                    callback(errorMessage, {}, false);
                }
            }
            
            return response;
        } catch (error) {
            let errorMessage = 'An error occurred while updating the user';
            let validationErrors = null;
           
            if (error.message) {
                errorMessage = error.message;
            }
            if (error.validationErrors && Array.isArray(error.validationErrors)) {
                validationErrors = error.validationErrors;
            }
            dispatch({
                type: COMPANY_USERS_FAIL,
                payload: errorMessage,
                validationErrors: validationErrors
            });
            if (callback) {
                callback(errorMessage, {}, false);
            }
            throw error;
        }
    };
};

// Delete company user
export const deleteCompanyUserAction = (companyId, profileId) => {
    return async (dispatch) => {
        try {
            dispatch(setLoading());

            const response = await CompanyUsersService.removeUserFromCompany(companyId, profileId);
            
            if (response.success) {
                dispatch({
                    type: COMPANY_USER_DELETE_SUCCESS,
                    payload: profileId
                });
            } else {
                dispatch({
                    type: COMPANY_USERS_FAIL,
                    payload: response.message || 'Failed to delete user'
                });
            }
            
            return response;
        } catch (error) {
            const errorMessage = error.message || 'An error occurred while deleting the user';
            dispatch({
                type: COMPANY_USERS_FAIL,
                payload: errorMessage
            });
            throw error;
        }
    };
};

// Get my companies
export const getMyCompaniesAction = () => {
    return async (dispatch) => {
        try {
            dispatch(setLoading());
            
            const response = await CompanyUsersService.getMyCompanies();
            
            if (response.success) {
                dispatch({
                    type: MY_COMPANIES_SUCCESS,
                    payload: response.data
                });
            } else {
                dispatch({
                    type: COMPANY_USERS_FAIL,
                    payload: response.message || 'Failed to fetch companies'
                });
            }
            
            return response;
        } catch (error) {
            const errorMessage = error.message || 'An error occurred while fetching companies';
            dispatch({
                type: COMPANY_USERS_FAIL,
                payload: errorMessage
            });
            throw error;
        }
    };
};

// ============ Role Management Actions ============

// Assign role to company user
export const assignRoleToCompanyUserAction = (companyId, assignmentData) => {
    return async (dispatch) => {
        try {
            dispatch({ type: COMPANY_USER_ASSIGNMENTS_LOADING });
            
            const response = await CompanyUsersService.assignUserRole(companyId, assignmentData);
            
            if (response.success) {
                dispatch({
                    type: COMPANY_USER_ROLE_ASSIGN_SUCCESS,
                    payload: response.data
                });
            } else {
                // Handle validation errors
                if (response.data && Array.isArray(response.data)) {
                    dispatch({
                        type: COMPANY_USERS_FAIL,
                        payload: response.message,
                        validationErrors: response.data
                    });
                } else {
                    dispatch({
                        type: COMPANY_USERS_FAIL,
                        payload: response.message || 'Failed to assign role'
                    });
                }
            }
            
            return response;
        } catch (error) {
            let errorMessage = 'An error occurred while assigning role';
            let validationErrors = null;
            
            if (error.data && Array.isArray(error.data)) {
                validationErrors = error.data;
                errorMessage = error.message || 'Validation errors occurred';
            } else if (error.message) {
                errorMessage = error.message;
            }
            
            dispatch({
                type: COMPANY_USERS_FAIL,
                payload: errorMessage,
                validationErrors: validationErrors
            });
            throw error;
        }
    };
};

// Get company user assignments
export const getCompanyUserAssignmentsAction = (companyId, params = {}) => {
    return async (dispatch) => {
        try {
            dispatch({ type: COMPANY_USER_ASSIGNMENTS_LOADING });
            
            const response = await CompanyUsersService.getCompanyUserAssignments(companyId, params);
            
            if (response.success) {
                dispatch({
                    type: COMPANY_USER_ASSIGNMENTS_SUCCESS,
                    payload: response.data
                });
            } else {
                dispatch({
                    type: COMPANY_USERS_FAIL,
                    payload: response.message || 'Failed to fetch role assignments'
                });
            }
            
            return response;
        } catch (error) {
            const errorMessage = error.message || 'An error occurred while fetching role assignments';
            dispatch({
                type: COMPANY_USERS_FAIL,
                payload: errorMessage
            });
            throw error;
        }
    };
};

// Update company user role assignment
export const updateCompanyUserRoleAssignmentAction = (companyId, assignmentId, updateData) => {
    return async (dispatch) => {
        try {
            dispatch({ type: COMPANY_USER_ASSIGNMENTS_LOADING });
            
            const response = await CompanyUsersService.updateRoleAssignment(
                companyId,
                assignmentId,
                updateData
            );
            
            if (response.success) {
                dispatch({
                    type: COMPANY_USER_ROLE_UPDATE_SUCCESS,
                    payload: response.data
                });
            } else {
                // Handle validation errors
                if (response.data && Array.isArray(response.data)) {
                    dispatch({
                        type: COMPANY_USERS_FAIL,
                        payload: response.message,
                        validationErrors: response.data
                    });
                } else {
                    dispatch({
                        type: COMPANY_USERS_FAIL,
                        payload: response.message || 'Failed to update role assignment'
                    });
                }
            }
            
            return response;
        } catch (error) {
            let errorMessage = 'An error occurred while updating role assignment';
            let validationErrors = null;
            
            if (error.data && Array.isArray(error.data)) {
                validationErrors = error.data;
                errorMessage = error.message || 'Validation errors occurred';
            } else if (error.message) {
                errorMessage = error.message;
            }
            
            dispatch({
                type: COMPANY_USERS_FAIL,
                payload: errorMessage,
                validationErrors: validationErrors
            });
            throw error;
        }
    };
};

// Remove company user role assignment
export const removeCompanyUserRoleAssignmentAction = (companyId, assignmentId) => {
    return async (dispatch) => {
        try {
            dispatch({ type: COMPANY_USER_ASSIGNMENTS_LOADING });
            
            const response = await CompanyUsersService.removeRoleAssignment(companyId, assignmentId);
            
            if (response.success) {
                dispatch({
                    type: COMPANY_USER_ROLE_REMOVE_SUCCESS,
                    payload: assignmentId
                });
            } else {
                dispatch({
                    type: COMPANY_USERS_FAIL,
                    payload: response.message || 'Failed to remove role assignment'
                });
            }
            
            return response;
        } catch (error) {
            const errorMessage = error.message || 'An error occurred while removing role assignment';
            dispatch({
                type: COMPANY_USERS_FAIL,
                payload: errorMessage
            });
            throw error;
        }
    };
};
